import {
  type FocusStats,
  FocusStatsSchema,
  type Soundscape,
  type SoundscapePosition,
  SoundscapePositionSchema,
  SoundscapeSchema,
} from '../model/schema'

export interface SoundscapeDto {
  slug: string
  title: string
  modality: string
  kind: string
}

export function toSoundscape(dto: SoundscapeDto): Soundscape {
  return SoundscapeSchema.parse({
    slug: dto.slug,
    title: dto.title,
    modality: dto.modality,
    kind: dto.kind,
  })
}

export interface FocusStatsDto {
  today_seconds: number
  week_seconds: number
  total_seconds: number
}

export function toFocusStats(dto: FocusStatsDto): FocusStats {
  return FocusStatsSchema.parse({
    todaySeconds: dto.today_seconds,
    weekSeconds: dto.week_seconds,
    totalSeconds: dto.total_seconds,
  })
}

export interface SoundscapePositionDto {
  slug: string
  position_seconds: number
  updated_at: string
}

export function toSoundscapePosition(dto: SoundscapePositionDto): SoundscapePosition {
  return SoundscapePositionSchema.parse({
    slug: dto.slug,
    positionSeconds: dto.position_seconds,
    updatedAt: dto.updated_at,
  })
}
